import React from "react";
import { CtaButton } from "./CtaButton";
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-moss bg-deep/95 px-4 pb-4 pt-3 backdrop-blur md:hidden" data-id="element-110" data-mp="1oyexokcbos3z">
      <div className="flex items-center gap-3" data-id="element-111" data-mp="1t1bjsl12n6co">
        <div className="leading-tight" data-id="element-112" data-mp="1syfn100ymnpt">
          <p className="text-[10px] font-semibold tracking-wider text-white/60" data-id="element-113" data-mp="1xzli34i3en2i">2 LIVRES + 5 BONUS</p>
          <p className="font-display text-2xl font-bold text-gold" data-id="element-114" data-mp="119vq6713kjcy">29 €</p>
        </div>
        <CtaButton label="Voir l'offre" action="offer" size="md" className="flex-1" data-id="element-115" data-mp="15a66acilsq5j" />
      </div>
    </div>;
}